export const AD_SLIDER_CONSTANT = {
  ADS_SLIDER_DATA: "/advertising",
};
